import { PreSalesAnswers } from '../../../utils/pre-sales-questionnaire-evaluator';
import { PreSalesQuestion } from '../../../dto/model';

export const PRE_SALES_LIVE_HEAT_LOAD_REQUIRED_KEYS = [
  'plz',
  'construction_year',
  'house_position',
  'heating_temperature',
  'insulated_roof',
  'insulated_facade',
  'isolated_windows',
  'living_area',
  'heater_type',
  'heating_year',
  'heating_type',
  'heating_type2',
] as const;

export const PRE_SALES_LIVE_HEAT_LOAD_CONSUMPTION_KEYS = [
  'oil_consumption',
  'gas_consumption',
  'pellet_consumption',
  'heatpump_consumption',
  'energy_consumption',
  'wood_consumption',
  'lignite_consumption',
  'coal_consumption',
] as const;

const isLiveHeatLoadAnswerPresent = (value: unknown) =>
  value !== null && value !== undefined && value !== '';

export const getPreSalesLiveHeatLoadProgress = (
  answers: PreSalesAnswers,
  visibleQuestions: PreSalesQuestion[],
): number => {
  const visibleQuestionKeys = new Set(
    visibleQuestions.map((question) => question.questionKey),
  );
  const visibleRequiredKeys = PRE_SALES_LIVE_HEAT_LOAD_REQUIRED_KEYS.filter(
    (key) => visibleQuestionKeys.has(key),
  );
  const visibleConsumptionKeys = PRE_SALES_LIVE_HEAT_LOAD_CONSUMPTION_KEYS.filter(
    (key) => visibleQuestionKeys.has(key),
  );
  const answeredRequiredCount = visibleRequiredKeys.filter(
    (key) => isLiveHeatLoadAnswerPresent(answers[key]),
  ).length;
  const hasVisibleConsumptionQuestion = visibleConsumptionKeys.length > 0;
  const hasAnyConsumptionAnswer = visibleConsumptionKeys.some(
    (key) => isLiveHeatLoadAnswerPresent(answers[key]),
  );
  const totalUnits =
    visibleRequiredKeys.length + Number(hasVisibleConsumptionQuestion);

  return totalUnits === 0 ? 0 : (
    (answeredRequiredCount + Number(hasAnyConsumptionAnswer))
    / totalUnits
  ) * 100;
};
